var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1-Wallet/Payment_01",
    transform: "translate(-1246.000000, -423.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy",
    transform: "translate(1235.000000, 357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3297872,3.04182573 C17.8042553,3.04182573 19.0212766,4.23349239 19.0212766,5.67724239 L19.0212766,5.67724239 L19.0212766,7.07515906 C20.3553191,7.25849239 21.3617021,8.35849239 21.3617021,9.68765906 L21.3617021,9.68765906 L21.3617021,10.8334924 L21.4787234,10.8334924 C22.3212766,10.8334924 23,11.4980757 23,12.3230757 L23,12.3230757 L23,15.9897424 C23,16.8147424 22.3212766,17.4793257 21.4787234,17.4793257 L21.4787234,17.4793257 L21.3617021,17.4793257 L21.3617021,18.7397424 C21.3617021,20.1834924 20.1446809,21.3751591 18.6702128,21.3751591 L18.6702128,21.3751591 L3.69148936,21.3751591 C2.21702128,21.3751591 1,20.1834924 1,18.7397424 L1,18.7397424 L1,5.79182573 C1.02340426,4.25640906 2.3106383,3.04182573 3.85531915,3.04182573 L3.85531915,3.04182573 Z M21.3617021,12.4376591 L17.5,12.4376591 C16.5404255,12.4376591 15.7446809,13.2168257 15.7446809,14.1564091 C15.7446809,15.0959924 16.5404255,15.8751591 17.5,15.8751591 L17.5,15.8751591 L21.3617021,15.8751591 L21.3617021,12.4376591 Z M17.9680851,13.0105757 C18.6143758,13.0105757 19.1382979,13.5235828 19.1382979,14.1564091 C19.1382979,14.7892353 18.6143758,15.3022424 17.9680851,15.3022424 C17.3217944,15.3022424 16.7978723,14.7892353 16.7978723,14.1564091 C16.7978723,13.5235828 17.3217944,13.0105757 17.9680851,13.0105757 Z M16.306383,4.64599239 L3.85531915,4.64599239 C3.2,4.64599239 2.63829787,5.17307573 2.63829787,5.83765906 C2.63829787,6.50224239 3.2,7.05224239 3.85531915,7.05224239 L3.85531915,7.05224239 L17.3595745,7.05224239 L17.3595745,5.67724239 C17.3595745,5.10432573 16.8914894,4.64599239 16.306383,4.64599239 L16.306383,4.64599239 Z",
    id: "Wallet"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.0becffe612ece34e62731f6b7a43a7cf.svg";
export { ForwardRef as ReactComponent };